var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C11.9853 0 14 2.01471 14 4.5V13.938C13.9999 13.9974 14.0212 14.0549 14.06 14.1C14.994 15.1841 15.5054 16.569 15.5 18C15.5 21.3137 12.8137 24 9.5 24C6.18631 24 3.5 21.3137 3.5 18C3.49466 16.569 4.00598 15.1841 4.94 14.1C4.97879 14.0549 5.00006 13.9974 5 13.938V4.5C5 2.01471 7.01474 0 9.5 0ZM5.79752 19.5123C6.41183 21.0166 7.87512 21.9998 9.5 22C11.1249 21.9998 12.5882 21.0166 13.2025 19.5123C13.8168 18.0081 13.4602 16.2817 12.3 15.144C12.1082 14.9559 12 14.6986 12 14.43V4.5C12 3.11926 10.8807 2 9.5 2C8.11929 2 7 3.11926 7 4.5V14.43C6.99997 14.6986 6.89185 14.9559 6.70001 15.144C5.53983 16.2817 5.18317 18.0081 5.79752 19.5123Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.611 16.337C10.5416 16.2906 10.4999 16.2125 10.5 16.129V8.5C10.5 7.94772 10.0523 7.5 9.5 7.5C8.94772 7.5 8.5 7.94772 8.5 8.5V16.129C8.50007 16.2125 8.45842 16.2906 8.389 16.337C7.65645 16.8264 7.3304 17.7375 7.5861 18.5805C7.8418 19.4236 8.61902 20 9.5 20C10.381 20 11.1582 19.4236 11.4139 18.5805C11.6696 17.7375 11.3436 16.8264 10.611 16.337Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.5H17C16.4477 11.5 16 11.9477 16 12.5C16 13.0523 16.4477 13.5 17 13.5H19.5C20.0523 13.5 20.5 13.0523 20.5 12.5C20.5 11.9477 20.0523 11.5 19.5 11.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.5H19.5C20.0523 5.5 20.5 5.05228 20.5 4.5C20.5 3.94772 20.0523 3.5 19.5 3.5H17C16.4477 3.5 16 3.94772 16 4.5C16 5.05228 16.4477 5.5 17 5.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5H17C16.4477 7.5 16 7.94772 16 8.5C16 9.05228 16.4477 9.5 17 9.5H19.5C20.0523 9.5 20.5 9.05228 20.5 8.5C20.5 7.94772 20.0523 7.5 19.5 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.78497277.svg";
export { ForwardRef as ReactComponent };